export class InvalidParameterException extends Error {
  constructor(msg: string) {
    super(msg);

    Object.setPrototypeOf(this, InvalidParameterException.prototype);
  }
}

export class NotImplementedException extends Error {
  constructor(msg: string) {
    super(msg);

    Object.setPrototypeOf(this, NotImplementedException.prototype);
  }
}

export class ValidationException extends Error {
  constructor(msg: string) {
    super(msg);

    Object.setPrototypeOf(this, ValidationException.prototype);
  }
}
